import { render, staticRenderFns } from "./RequirementPreview.vue?vue&type=template&id=35d06742&scoped=true&"
import script from "./RequirementPreview.vue?vue&type=script&lang=js&"
export * from "./RequirementPreview.vue?vue&type=script&lang=js&"
import style0 from "./RequirementPreview.vue?vue&type=style&index=0&id=35d06742&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d06742",
  null
  
)

export default component.exports